import React, { useState, useEffect } from "react";
import { Modal, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import config from "../../../../config/config";

const BlogOrdering = ({ isOpen, onClose, blogs, onOrderUpdated }) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDatalist([...blogs]); 
    }
  }, [isOpen]);

  const handleOrderUpdate = async () => {
    try {
      setLoading(true);
      const orderPayload = datalist.map((item, index) => ({
        _id: item._id,
        position: index,
      }));

      const { data } = await axios.post(`${config.api_url}blogs/reorder`, {
        order: orderPayload,
      });

      notification.success({
        message: "Blog order updated successfully!",
      });

      // Update parent with new order
      if (onOrderUpdated) {
        onOrderUpdated(datalist);
      }

      onClose();
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Error updating blog order",
      });
    } finally {
      setLoading(false);
    }
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    const items = Array.from(datalist);
    const [removed] = items.splice(source.index, 1);
    items.splice(destination.index, 0, removed);
    setDatalist(items);
  };

  return (
    <Modal
      title="Reorder Blogs"
      visible={isOpen}
      onOk={handleOrderUpdate}
      onCancel={onClose}
      okText="Update"
      confirmLoading={loading}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="blog-droppable">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ maxHeight: 400, overflowY: "auto" }}
            >
              {datalist.map((blog, index) => (
                <Draggable key={blog._id} draggableId={blog._id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={{
                        ...provided.draggableProps.style,
                        padding: "10px",
                        marginBottom: "8px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        boxShadow: snapshot.isDragging
                          ? "0 0 .4rem #666"
                          : "none",
                        background: "#fff",
                      }}
                    >
                      <span style={{ marginLeft: "12px", flex: 1 }}>
                        {blog.title}
                      </span>
                      <div
                        {...provided.dragHandleProps}
                        style={{ cursor: "grab" }}
                      >
                        ☰
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default BlogOrdering;
